import { Routes, Route } from 'react-router-dom';
import BranchesList from './pages/BranchesList';
import BranchCreateAndViewDetails from './pages/BranchCreateAndViewDetails';

function BranchesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BranchesList />} />
      <Route path="/create" element={<BranchCreateAndViewDetails />} />
      <Route path="/edit/:id" element={<BranchCreateAndViewDetails />} />
      <Route path="/view/:id" element={<BranchCreateAndViewDetails />} />
    </Routes>
  );
}

export default BranchesRoutes;
